/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Card_Consulting_TitleInputs */

const en_landing_card_consulting_title = /** @type {(inputs: Landing_Card_Consulting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulting`)
};

const id_landing_card_consulting_title = /** @type {(inputs: Landing_Card_Consulting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultasi`)
};

/**
* | output |
* | --- |
* | "Consulting" |
*
* @param {Landing_Card_Consulting_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_card_consulting_title = /** @type {((inputs?: Landing_Card_Consulting_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Card_Consulting_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_card_consulting_title(inputs)
	return en_landing_card_consulting_title(inputs)
});